/* eslint-disable import/no-cycle */

import { call, put, takeEvery } from 'redux-saga/effects';
import { reset } from 'redux-form';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import { symplOffers, pickupPoints, commands } from '../../api/api';
import history from '../../router/history';
import {
  GET_PRICES,
  GET_PRICES_SUCCESS,
  GET_PRICES_FAILURE,
  GET_PICKUP_POINTS,
  GET_PICKUP_POINTS_SUCCESS,
  GET_PICKUP_POINTS_FAILURE,
  ADD_COMMAND,
  ADD_COMMAND_SUCCESS,
  ADD_COMMAND_FAILURE
} from './addCommandActions';

import { ADD_CHECKED_COMMANDS_IDS } from '../commands/commandsActions';

import logger from '../../utils/logger';

export function* getPrices(action) {
  const closeLoading = displayLoading(
    `Récupération des offres de livraison en cours`
  );
  try {
    const response = yield call(symplOffers.getPrices, action.payload);
    if (response.data.success === true) {
      yield put({
        type: GET_PRICES_SUCCESS,
        payload: response.data
      });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_PRICES_FAILURE });
  } finally {
    closeLoading();
  }
}

export function* getPickupPoints(action) {
  const closeLoading = displayLoading(
    `Récupération des points relais en cours`
  );
  try {
    const response = yield call(pickupPoints.getPickupPoints, action.payload);
    if (response.data.success === true) {
      yield put({
        type: GET_PICKUP_POINTS_SUCCESS,
        payload: response.data
      });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_PICKUP_POINTS_FAILURE });
  } finally {
    closeLoading();
  }
}

export function* addCommand(action) {
  const closeLoading = displayLoading(`Création de votre commande en cours`);
  try {
    const response = yield call(commands.addCommand, action.payload);
    if (response.data.success === true) {
      yield put({
        type: ADD_COMMAND_SUCCESS,
        payload: response.data
      });
      displaySuccess(`Création de votre commande réussi`);
      yield put(reset('addCommandForm'));
      if (!action.payload.readyToBePickedUp) {
        yield put({
          type: ADD_CHECKED_COMMANDS_IDS,
          data: { commandsIds: [response.data.commandId] }
        });
        yield call(history.push, '/not-sent');
      } else {
        yield call(history.push, '/sent-by-me');
      }
    }
  } catch (error) {
    logger(error);
    yield put({ type: ADD_COMMAND_FAILURE });
  } finally {
    closeLoading();
  }
}

const addCommandSaga = [
  takeEvery(GET_PRICES, getPrices),
  takeEvery(GET_PICKUP_POINTS, getPickupPoints),
  takeEvery(ADD_COMMAND, addCommand)
];

export default addCommandSaga;
